// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

const statusMap = {
  active: 2,
  obsolete: 1,
  invalid: 0,
}

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'status' :
        av = statusMap[a[col].toLowerCase()]
        bv = statusMap[b[col].toLowerCase()]
        break

      default :
        av = `${a[col]}`.toLowerCase()
        bv = `${b[col]}`.toLowerCase()
        break
    }

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// default the data to sort by contactCode
export const getSortColByFormValues = () => 'contactCode'
